// extracted by mini-css-extract-plugin
export default {"root":"ApplicationsSelectorList_root__3YqxZ"};